<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-text-field
            label="Title"
            v-model.trim="doc.title"
            type="text"
            placeholder="Functionality title"
            id="title"
          ></v-text-field>
          <v-textarea
            label="Description"
            v-model.trim="doc.description"
            type="text"
            placeholder="Functionality description"
            id="description"
          ></v-textarea>
          <v-select
            :items="dropdownCategories"
            label="Functionality Value"
            v-model.trim="doc.value"
          ></v-select>

          <v-select
            :items="tags"
            label="Tags"
            v-model.trim="doc.tag"
          ></v-select>

          <input
            type="hidden"
            v-model.trim="doc.project"
            id="project"
            name="project"
          />

          <v-textarea
            label="Note"
            v-model.trim="doc.note"
            type="text"
            placeholder="Notes"
            id="note"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
// const fb = require("@/firebaseConfig.js");

export default {
  name: "UserFunctionalityForm",
  data() {
    return {
      dropdownCategories: ["5", "10", "20", "25", "30", "35", "40", "45", "50"],
    };
  },
  props: {
    doc: Object,
    tags: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
